import posthog from "posthog-js";
import { cloneDeep } from "es-toolkit";
import { useFeatureFlagStore } from "@/store/useFeatureFlagStore";

let posthogInitialized = false;

export function usePostHog() {
	if (posthogInitialized) {
		return { posthog };
	}
	posthogInitialized = true;

	posthog.onFeatureFlags(() => {
		const flags = cloneDeep(posthog.featureFlags.getFlagsWithDetails());
		useFeatureFlagStore().$reset(flags);
	});

	return { posthog };
}
